// src/components/Footer.js
import React from 'react';

const Footer = () => {
    return (
        <footer>
            <p>&copy; <span id="currentYear">{new Date().getFullYear()}</span> Deep Parmar</p>
        </footer>
    );
};

export default Footer;
